import { render, staticRenderFns } from "./BaseFeatureButton.vue?vue&type=template&id=715f8aca&"
import script from "./BaseFeatureButton.vue?vue&type=script&lang=js&"
export * from "./BaseFeatureButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports